<script lang="ts">
  import { getContext } from "svelte";
  import type { Writable } from "svelte/store";
  import type { CommentsStateType } from "./MaterialComments.svelte";
  import CommentRenderer from "./CommentRenderer.svelte";

  const state: Writable<CommentsStateType> = getContext('comments')

  let filteredComments: CommentsStateType['orderedComments'] = []
  $: {
    filteredComments = $state.orderedComments.filter(commentId => {
      const comment = $state.comments[commentId]
      return !comment.hidden
    })
  }

  const renderEnd = (_node: HTMLElement) => {
    window.dispatchEvent(new Event('comments-rendered'))
  }
</script>

<div style="display: flex; flex-direction: column" use:renderEnd>
  {#each filteredComments as commentId (commentId)}
    <CommentRenderer
      commentId={commentId}
    />
  {/each}
</div>
